// Pesquisa de satisfação: indicadores (CSAT, resolução, taxa de resposta), respostas, pendências de tratamento,
// configuração (desligada por padrão) e relatório mensal. Comentários e técnico só com satisfacao.comentarios.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Chip, FormControlLabel, MenuItem, Paper, Switch, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs,
  TextField, Typography,
} from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import suporteApi, { mensagemErro } from "../api";
import { dataBR } from "../comum";
import { usePermissao } from "../permissoes";

const hojeIso = () => new Date().toISOString().slice(0, 10);
const somaDias = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const pct = (v) => (v === null || v === undefined ? "não apurado" : `${v}%`);

const Numero = ({ rotulo, valor, meta, abaixo }) => (
  <Paper variant="outlined" style={{ padding: "8px 14px", minWidth: 140, borderColor: abaixo ? "#c62828" : undefined }}>
    <Typography variant="h6" style={{ color: abaixo ? "#c62828" : undefined }}>{valor}</Typography>
    <Typography variant="caption">{rotulo}{meta !== undefined ? ` (meta ${meta}%)` : ""}</Typography>
  </Paper>
);

const Pendencia = ({ x, onMudou }) => {
  const [f, setF] = useState({ responsavel: x.responsavel || "", acao: "", conclusao: "" });
  const pode = usePermissao("satisfacao.tratar");
  const salvar = async (extra = {}) => {
    try {
      await suporteApi.put(`/api/satisfacao/pendencias/${x.id}`, {
        responsavel: f.responsavel || null, acao: f.acao || null, conclusao: f.conclusao || null, ...extra });
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Paper variant="outlined" style={{ padding: 10, margin: "8px 0" }}>
      <Typography variant="body2">
        <Chip size="small" label={x.prioridade} style={{ background: x.prioridade === "ALTA" ? "#c62828" : "#f9a825", color: "#fff" }} />{" "}
        Protocolo <b>{x.protocolo}</b> · {x.estrelas}★ · {x.resolvido ? "resolvido" : "não resolvido"}{x.motivo ? ` · ${x.motivo}` : ""} ·
        atendente {x.atendente || "—"} · prazo {x.prazo ? dataBR(x.prazo) : "—"} · <b>{x.status}</b>
        {x.primeiro_contato_em ? ` · 1º contato ${dataBR(x.primeiro_contato_em)}` : ""}
      </Typography>
      {x.acao && <Typography variant="caption" component="div">Ação: {x.acao}</Typography>}
      {pode && x.status !== "CONCLUIDA" && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 6 }}>
          <TextField size="small" label="Responsável" value={f.responsavel} onChange={(e) => setF({ ...f, responsavel: e.target.value })} />
          <TextField size="small" label="Ação" value={f.acao} onChange={(e) => setF({ ...f, acao: e.target.value })} />
          <TextField size="small" label="Conclusão" value={f.conclusao} onChange={(e) => setF({ ...f, conclusao: e.target.value })} />
          {!x.primeiro_contato_em && <Button size="small" onClick={() => salvar({ primeiro_contato: true, status: "EM_TRATAMENTO" })}>Fiz o 1º contato</Button>}
          <Button size="small" onClick={() => salvar({ status: "EM_TRATAMENTO" })}>Salvar</Button>
          <Button size="small" color="primary" disabled={!f.conclusao && !x.conclusao} onClick={() => salvar({ status: "CONCLUIDA" })}>Concluir</Button>
        </div>
      )}
    </Paper>
  );
};

const Configuracao = () => {
  const [c, setC] = useState(null);
  useEffect(() => { suporteApi.get("/api/satisfacao/config").then((r) => setC(r.data)).catch((e) => toast.error(mensagemErro(e))); }, []);
  if (!c) return null;
  const n = (k, rotulo) => <TextField size="small" type="number" margin="dense" label={rotulo} value={c[k]} onChange={(e) => setC({ ...c, [k]: Number(e.target.value) })} />;
  const meta = (k, rotulo) => <TextField size="small" type="number" margin="dense" label={rotulo} value={c.metas[k]}
    onChange={(e) => setC({ ...c, metas: { ...c.metas, [k]: Number(e.target.value) } })} />;
  const salvar = async () => {
    try {
      const { bloqueios_recentes: _b, ...corpo } = c;
      setC({ ...c, ...(await suporteApi.put("/api/satisfacao/config", corpo)).data });
      toast.success("Configuração salva");
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Paper variant="outlined" style={{ padding: 14, margin: "10px 0", maxWidth: 760 }}>
      <FormControlLabel control={<Switch checked={c.ativo} onChange={(e) => setC({ ...c, ativo: e.target.checked })} color="primary" />}
        label={c.ativo ? "Pesquisa ligada: o convite vai junto do protocolo" : "Pesquisa desligada"} />
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {n("validade_dias", "Link vale (dias)")}{n("intervalo_dias", "Anti-cansaço (dias)")}{n("amostragem_pct", "Amostragem (%)")}
      </div>
      <TextField size="small" margin="dense" fullWidth label="Clientes na pesquisa (vazio = todos; separados por vírgula)"
        value={c.clientes.join(", ")} onChange={(e) => setC({ ...c, clientes: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })} />
      <TextField size="small" margin="dense" fullWidth label="Texto do convite" value={c.texto_convite} onChange={(e) => setC({ ...c, texto_convite: e.target.value })} />
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{meta("csat_min", "Meta CSAT (%)")}{meta("resolucao_min", "Meta resolução (%)")}{meta("resposta_min", "Meta taxa de resposta (%)")}</div>
      <Button color="primary" variant="contained" size="small" onClick={salvar} style={{ marginTop: 8 }}>Salvar</Button>
      {(c.bloqueios_recentes || []).length > 0 && (
        <>
          <Typography variant="subtitle2" style={{ marginTop: 12 }}>Convites não enviados (30 dias)</Typography>
          {c.bloqueios_recentes.map((b) => <Typography key={b.motivo} variant="caption" component="div">{b.motivo}: {b.n}</Typography>)}
        </>
      )}
    </Paper>
  );
};

const Satisfacao = () => {
  const [aba, setAba] = useState("indicadores");
  const [per, setPer] = useState({ de: somaDias(hojeIso(), -30), ate: hojeIso() });
  const [k, setK] = useState(null);
  const [resp, setResp] = useState([]);
  const [pend, setPend] = useState([]);
  const [mes, setMes] = useState(hojeIso().slice(0, 7));
  const configura = usePermissao("satisfacao.configurar");

  const carregar = useCallback(() => {
    suporteApi.get("/api/satisfacao/indicadores", { params: per }).then((r) => setK(r.data)).catch((e) => toast.error(mensagemErro(e)));
    suporteApi.get("/api/satisfacao/respostas", { params: per }).then((r) => setResp(r.data)).catch(() => {});
    suporteApi.get("/api/satisfacao/pendencias").then((r) => setPend(r.data)).catch(() => {});
  }, [per]);
  useEffect(() => { carregar(); }, [carregar]);
  const relatorio = async () => {
    try {
      const { data } = await suporteApi.get("/api/satisfacao/relatorio-mensal", { params: { mes }, responseType: "text" });
      const j = window.open("", "_blank");
      if (j) { j.document.write(data); j.document.close(); }
    } catch (e) { toast.error(mensagemErro(e)); }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>Pesquisa de satisfação</Title>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <TextField size="small" type="date" label="De" InputLabelProps={{ shrink: true }} value={per.de} onChange={(e) => setPer({ ...per, de: e.target.value })} />
          <TextField size="small" type="date" label="Até" InputLabelProps={{ shrink: true }} value={per.ate} onChange={(e) => setPer({ ...per, ate: e.target.value })} />
          <TextField size="small" type="month" label="Mês" InputLabelProps={{ shrink: true }} value={mes} onChange={(e) => setMes(e.target.value)} />
          <Button size="small" variant="outlined" onClick={relatorio}>Relatório mensal</Button>
        </div>
      </MainHeader>
      <Tabs value={aba} onChange={(e, v) => setAba(v)} indicatorColor="primary" textColor="primary">
        <Tab value="indicadores" label="Indicadores" /><Tab value="respostas" label={`Respostas (${resp.length})`} />
        <Tab value="pendencias" label={`Pendências (${pend.length})`} />{configura && <Tab value="config" label="Configuração" />}
      </Tabs>

      {aba === "indicadores" && k && (
        <>
          <div style={{ display: "flex", gap: 8, margin: "10px 0", flexWrap: "wrap" }}>
            <Numero rotulo="CSAT" valor={pct(k.csat)} meta={k.metas.csat_min} abaixo={k.csat !== null && k.csat < k.metas.csat_min} />
            <Numero rotulo="Resolução" valor={pct(k.resolucao)} meta={k.metas.resolucao_min} abaixo={k.resolucao !== null && k.resolucao < k.metas.resolucao_min} />
            <Numero rotulo="Taxa de resposta" valor={pct(k.taxa_resposta)} meta={k.metas.resposta_min} abaixo={k.taxa_resposta !== null && k.taxa_resposta < k.metas.resposta_min} />
            <Numero rotulo="Nota média" valor={k.nota_media ?? "—"} />
            <Numero rotulo="Convites entregues" valor={k.convites_entregues} />
            <Numero rotulo="Respostas" valor={k.respostas} />
            <Numero rotulo="Pendências críticas abertas" valor={k.pendencias_criticas_abertas} abaixo={k.pendencias_criticas_abertas > 0} />
            <Numero rotulo="Tempo de retorno (h)" valor={k.tempo_retorno_h ?? "—"} />
          </div>
          <Typography variant="subtitle2">Por atendente</Typography>
          <Paper variant="outlined" style={{ overflowX: "auto", marginBottom: 10 }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>Atendente</TableCell><TableCell>Avaliações</TableCell><TableCell>CSAT</TableCell><TableCell>Nota média</TableCell></TableRow></TableHead>
              <TableBody>
                {k.por_atendente.map((x) => (
                  <TableRow key={x.atendente || "-"}><TableCell>{x.atendente || "—"}</TableCell><TableCell>{x.avaliacoes}</TableCell>
                    <TableCell>{x.observacao || pct(x.csat)}</TableCell><TableCell>{x.nota_media ?? "—"}</TableCell></TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
          <Typography variant="subtitle2">Motivos de insatisfação</Typography>
          {k.motivos.length === 0 ? <Typography variant="body2" color="textSecondary">Nenhum no período.</Typography>
            : k.motivos.map((m) => <Typography key={m.motivo} variant="body2">• {m.motivo}: {m.n}</Typography>)}
        </>
      )}

      {aba === "respostas" && (
        <Paper variant="outlined" style={{ overflowX: "auto", marginTop: 10 }}>
          <Table size="small">
            <TableHead><TableRow><TableCell>Quando</TableCell><TableCell>Protocolo</TableCell><TableCell>Cliente</TableCell><TableCell>Atendente</TableCell>
              <TableCell>Nota</TableCell><TableCell>Resolvido</TableCell><TableCell>Motivo</TableCell><TableCell>Comentário</TableCell></TableRow></TableHead>
            <TableBody>
              {resp.length === 0 && <TableRow><TableCell colSpan={8}><Typography variant="body2" color="textSecondary">Nenhuma resposta no período.</Typography></TableCell></TableRow>}
              {resp.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{dataBR(r.respondido_em)}</TableCell><TableCell>{r.protocolo}</TableCell><TableCell>{r.cliente || "—"}</TableCell>
                  <TableCell>{r.atendente || "—"}</TableCell><TableCell>{"★".repeat(r.estrelas || 0)}</TableCell>
                  <TableCell>{r.resolvido ? "Sim" : r.resolvido === false ? "Não" : "—"}</TableCell><TableCell>{r.motivo || "—"}</TableCell>
                  <TableCell>{r.comentario || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {aba === "pendencias" && (pend.length === 0
        ? <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>Nenhuma pendência em aberto.</Typography>
        : pend.map((x) => <Pendencia key={`${x.id}-${x.status}-${x.primeiro_contato_em || ""}`} x={x} onMudou={carregar} />))}

      {aba === "config" && configura && <Configuracao />}
    </MainContainer>
  );
};

export default Satisfacao;
